<template>
    <div class="table-footer">
        <div class="row">
            <div class="col-md-4">
                <span>Show</span>
                <select class="form-control" v-model="showPerPage" @change="showPerPageChanged($event)">
                    <option>10</option>
                    <option>25</option>
                    <option>50</option>
                    <option>100</option>
                </select>
                <span>Entries</span>
            </div>
            <div class="col-md-4 text-center" >
            </div>
            <div class="col-md-4 text-right">
                <a href="javascript:void(0)" v-if="currentPageNumber != 1" @click="getPreviousPageList()">Previous </a>
				<select
					class="form-control selectpicker"
					style = 'max-width:80px;'
					id="brandFilter"
					v-model="currentPageNumber"
					@change="getNewPageList()"
                >
					<option
						v-for="index in totalNoOfPages"
						:key="index"
						:value="index"
					>{{index}}</option>
				</select>
                <a href="javascript:void(0)" v-if="(showPerPage == dspRowCount && (currentPageNumber!=totalNoOfPages))" @click="getNextPageList()"> Next</a>
				<div style = "padding-right:0px;padding-top:5px">{{getCount()}}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'DspTagListGridFooter',
    data() {
        return {
            totalNoOfPages:1,
            showPerPage: sessionStorage.getItem('dsp:showPerPage') || 25
        }
    },
    mounted() {
        this.calculateIndexPerPage()
    },
    computed: {
        currentPageNumber: {
            set(val) {
                this.$store.state.currentPageNumber = val
            },
            get() {
                return this.$store.state.currentPageNumber
            }
        },
        dspRows: {
            set(val) {
                this.$store.state.dspTagList = val;
            },
            get() {
                return this.$store.state.dspTagList;
            },
        },
        dspRowCount: {
            get() {
                return this.$store.state.dspRowCount;
            },
        },
        showDspRows: {
            set(val) {
                this.$store.state.showDspRows = val;
            },
            get() {
                return this.$store.state.showDspRows;
            },
        }
    },
    methods: {
        calculateIndexPerPage(){
            this.totalNoOfPages=Math.ceil(this.dspRowCount/this.showPerPage)
        },
        getCount(){
            let pageCount = this.showPerPage * (this.currentPageNumber - 1);
            let extendedcount = Math.min(parseInt(pageCount) + parseInt(this.showPerPage), this.dspRowCount);
            return	'Showing ' + (pageCount+1) + ' to ' + extendedcount + ' results of ' + this.dspRowCount;
        },
        showPerPageChanged(data) {
            this.calculateIndexPerPage()
            sessionStorage.setItem('dsp:showPerPage', data.target.selectedOptions[0].label)
            this.currentPageNumber = 1
            const params = {
                tag_type: (!this.$store.state.dspTagType || this.$store.state.dspTagType.name=='All Types')?'':this.$store.state.dspTagType.name,
                advertiser_id: this.$store.state.dspAdvertiser.value
            }
            this.$store.dispatch("getAllDsp",params)
        },
        getPreviousPageList() {
            if (this.currentPageNumber <= 1) {
                return
            }
            else {
                this.currentPageNumber -= 1
                const params = {
                tag_type: (!this.$store.state.dspTagType || this.$store.state.dspTagType.name=='All Types')?'':this.$store.state.dspTagType.name,
                advertiser_id: this.$store.state.dspAdvertiser.value
                }
                this.$store.dispatch("getAllDsp",params)
            }
        },
        getNextPageList() {
            this.currentPageNumber += 1
            const params = {
                tag_type: (!this.$store.state.dspTagType || this.$store.state.dspTagType.name=='All Types')?'':this.$store.state.dspTagType.name,
                advertiser_id: this.$store.state.dspAdvertiser.value
            }
            this.$store.dispatch("getAllDsp",params)
        },
        getNewPageList(){
            const params = {
                tag_type: (!this.$store.state.dspTagType || this.$store.state.dspTagType.name=='All Types')?'':this.$store.state.dspTagType.name,
                advertiser_id: this.$store.state.dspAdvertiser.value
            }
            this.$store.dispatch("getAllDsp",params)
        },
    },
}
</script>

<style lang="scss">

</style>
